import { render, staticRenderFns } from "./DialogAdd.vue?vue&type=template&id=66e5c7d0&scoped=true&"
import script from "./DialogAdd.vue?vue&type=script&lang=js&"
export * from "./DialogAdd.vue?vue&type=script&lang=js&"
import style0 from "./DialogAdd.vue?vue&type=style&index=0&id=66e5c7d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5c7d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e5c7d0')) {
      api.createRecord('66e5c7d0', component.options)
    } else {
      api.reload('66e5c7d0', component.options)
    }
    module.hot.accept("./DialogAdd.vue?vue&type=template&id=66e5c7d0&scoped=true&", function () {
      api.rerender('66e5c7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/components/DialogAdd.vue"
export default component.exports